webpackJsonp([0],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1m2L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['feedGroupIndex', 'feedIndex'],
  methods: {
    getInput: function getInput(key) {
      var feeds = this.$store.state.feeds;
      var feedGroup = feeds[this.feedGroupIndex];
      var feed = feedGroup[this.feedIndex];
      var input = feed[0];
      return input[key];
    },
    updateFeedGroupHeader: function updateFeedGroupHeader(key, value) {
      this.$store.commit({
        type: 'updateFeedGroupHeader',
        key: key,
        value: value,
        feedGroupIndex: this.feedGroupIndex,
        feedIndex: this.feedIndex
      });
    },
    deleteFeed: function deleteFeed() {
      this.$store.commit({
        type: 'deleteFeed',
        feedGroupIndex: this.feedGroupIndex,
        feedIndex: this.feedIndex
      });
    }
  },
  computed: {
    feedGroupName: {
      get: function get() {
        return this.getInput('value');
      },
      set: function set(value) {
        this.updateFeedGroupHeader('value', value);
      }
    },
    visible: {
      get: function get() {
        return this.getInput('visible');
      },
      set: function set(value) {
        this.updateFeedGroupHeader('visible', value);
      }
    },
    public: {
      get: function get() {
        return this.getInput('public');
      },
      set: function set(value) {
        this.updateFeedGroupHeader('public', value);
      }
    }
  }
});

/***/ }),

/***/ "20Wp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_Input__ = __webpack_require__("gcDA");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__inputs_Input__["a" /* default */],
  props: ['name']
});

/***/ }),

/***/ "27jF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedGroupHeader_vue__ = __webpack_require__("1m2L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_790257c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeedGroupHeader_vue__ = __webpack_require__("BB9y");
function injectStyle (ssrContext) {
  __webpack_require__("QHzf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedGroupHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_790257c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeedGroupHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2NdS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textInput"},[_c('div',{staticClass:"textInput-name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('div',{staticClass:"textInput-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"type":"text","placeholder":"..."},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3IVD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3K3G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_uploadcare_vue__ = __webpack_require__("uaPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_21871186_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_uploadcare_vue__ = __webpack_require__("jVck");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_uploadcare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_21871186_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_uploadcare_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3T1k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5nB1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("HluH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14310bd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("plZ0");
function injectStyle (ssrContext) {
  __webpack_require__("3T1k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14310bd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7C1O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7XbA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inputs_Text__ = __webpack_require__("NuOi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inputs_Number__ = __webpack_require__("Ku4v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inputs_List__ = __webpack_require__("YGI3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inputs_Html__ = __webpack_require__("ij5H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inputs_Image__ = __webpack_require__("MoaA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FeedGroupHeader__ = __webpack_require__("27jF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DashboardFooter__ = __webpack_require__("kU7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DashboardHeader__ = __webpack_require__("ILbD");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TextInput: __WEBPACK_IMPORTED_MODULE_1__inputs_Text__["a" /* default */],
    NumberInput: __WEBPACK_IMPORTED_MODULE_2__inputs_Number__["a" /* default */],
    ListInput: __WEBPACK_IMPORTED_MODULE_3__inputs_List__["a" /* default */],
    HtmlInput: __WEBPACK_IMPORTED_MODULE_4__inputs_Html__["a" /* default */],
    ImageInput: __WEBPACK_IMPORTED_MODULE_5__inputs_Image__["a" /* default */],
    FeedgroupheaderCom: __WEBPACK_IMPORTED_MODULE_6__components_FeedGroupHeader__["a" /* default */],
    DashboardheaderCom: __WEBPACK_IMPORTED_MODULE_8__components_DashboardHeader__["a" /* default */],
    DashboardfooterCom: __WEBPACK_IMPORTED_MODULE_7__components_DashboardFooter__["a" /* default */]
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.state.userInfo;
    },
    feeds: function feeds() {
      return this.$store.state.feeds;
    },
    currentFeed: function currentFeed() {
      return this.$store.state.currentFeed;
    }
  },
  mounted: function mounted() {
    this.setValue();
  },
  data: function data() {
    return {
      oldFeeds: []
    };
  },

  methods: {
    setValue: function setValue() {
      this.oldFeeds = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.feeds);
    },
    moveUp: function moveUp(feedIndex) {
      this.$store.commit({
        type: 'moveTo',
        feedGroupIndex: this.currentFeed,
        oldIndex: feedIndex,
        newIndex: feedIndex - 1
      });
    },
    moveDown: function moveDown(feedIndex) {
      this.$store.commit({
        type: 'moveTo',
        feedGroupIndex: this.currentFeed,
        oldIndex: feedIndex,
        newIndex: feedIndex + 1
      });
    }
  },
  watch: {
    feeds: {
      handler: function handler() {
        var _this = this;

        var preventChange = false;

        this.feeds.forEach(function (row, rowIndex) {
          if (row.length !== _this.oldFeeds[rowIndex].length) {
            return;
          }

          row.forEach(function (fields, fieldIndex) {
            if (fieldIndex === 0) {
              return;
            }

            var after = fields[0].visible || false;
            var oldRow = _this.oldFeeds[rowIndex];

            if (!oldRow[fieldIndex]) {
              return;
            }

            var before = oldRow[fieldIndex][0].visible || false;

            if (!preventChange) {
              preventChange = after !== before;
            }
          });
        });

        if (this.feeds.length < this.oldFeeds.length) {
          return;
        }

        this.setValue();

        if (preventChange) {
          preventChange = false;
          return;
        }

        this.$store.commit('changesFound', true);

        preventChange = false;
      },

      deep: true
    }
  }
});

/***/ }),

/***/ "82HU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['marginBottom', 'marginTop']
});

/***/ }),

/***/ "9nuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.bildspel),function(bild){return _c('div',{staticClass:"slide"},[_c('div',{staticClass:"h1"},[_vm._v("\n      "+_vm._s(bild.name)+"\n    ")]),_vm._v(" "),_c('img',{attrs:{"src":bild.bild}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A7MZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('contentgroup-com',{attrs:{"marginTop":"80"}},[_c('div',{staticClass:"settings"},[_c('div',{staticClass:"settings-fields"},[_c('div',{staticClass:"settings-input"},[_c('div',{staticClass:"settings-inputLabel"},[_vm._v("\n            Nuvarande Lösenord\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"text"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"settings-fieldsDivider"}),_vm._v(" "),_c('div',{staticClass:"settings-input"},[_c('div',{staticClass:"settings-inputLabel"},[_vm._v("\n            Nytt Lösenord\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"}],attrs:{"type":"password"},domProps:{"value":(_vm.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPassword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"settings-button"},[_c('button-com',{attrs:{"text":"Ändra Lösenord"},nativeOn:{"click":function($event){_vm.changePassword($event)}}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BB9y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feedGroupHeader"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.feedGroupName),expression:"feedGroupName"}],staticClass:"feedGroupHeader-name",attrs:{"type":"text","placeholder":"..."},domProps:{"value":(_vm.feedGroupName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.feedGroupName=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"feedGroupHeader-manageFeedGroupHolder"},[_c('div',{staticClass:"feedGroupHeader-manageFeedGroupButtonHolder"},[_c('button-com',{staticClass:"bm-ghost bm-onlyIcon",attrs:{"iconName":(_vm.visible) ? 'arrow-up' : 'arrow-down',"iconSize":"large","iconCircleColor":"#E9E9E9","tooltip":(_vm.visible) ? "Hide Fields" : "Show Fields"},nativeOn:{"click":function($event){_vm.visible = !_vm.visible}}})],1),_vm._v(" "),_c('div',{staticClass:"feedGroupHeader-manageFeedGroupButtonHolder"},[_c('button-com',{staticClass:"bm-ghost bm-onlyIcon",attrs:{"iconName":_vm.public ? 'public' : 'private',"iconSize":"large","iconCircleColor":"#E9E9E9","tooltip":_vm.public ? "Make Private" : "Make Public"},nativeOn:{"click":function($event){_vm.public = !_vm.public}}})],1),_vm._v(" "),_c('div',{staticClass:"feedGroupHeader-manageFeedGroupButtonHolder"},[_c('button-com',{staticClass:"bm-ghost bm-onlyIcon",attrs:{"iconName":"delete","iconSize":"large","iconCircleColor":"#E9E9E9","tooltip":"Delete"},nativeOn:{"click":function($event){_vm.deleteFeed($event)}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D1ON":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"numberInput"},[_c('div',{staticClass:"numberInput-name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('div',{staticClass:"numberInput-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"type":"number"},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ecmc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EgbF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentGroup_vue__ = __webpack_require__("82HU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9040136_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentGroup_vue__ = __webpack_require__("UfVl");
function injectStyle (ssrContext) {
  __webpack_require__("mJ7H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9040136_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HluH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['name', 'text', 'size', 'color', 'circleColor']
});

/***/ }),

/***/ "ILbD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardHeader_vue__ = __webpack_require__("g+qg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85f16122_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardHeader_vue__ = __webpack_require__("LwSW");
function injectStyle (ssrContext) {
  __webpack_require__("PUcz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85f16122_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KHUw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ku4v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Number_vue__ = __webpack_require__("SoBG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a007558_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Number_vue__ = __webpack_require__("D1ON");
function injectStyle (ssrContext) {
  __webpack_require__("LAt4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Number_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a007558_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Number_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LArW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LAt4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LheX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboardFooter"},[_c('div',{staticClass:"dashboardFooter-api"},[_c('button-com',{staticClass:"bm-ghost bm-onlyIcon",attrs:{"iconName":"link","iconSize":"large","iconColor":"#888","tooltip":""},nativeOn:{"click":function($event){_vm.goTo('//api.lootbox.se/v1/feed/' + _vm.feedId)}}})],1),_vm._v(" "),_c('usernav-com')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LwSW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboardHeader"},[_c('div',{staticClass:"dashboardHeader-container"},[_c('div',{staticClass:"dashboardHeader-feedColor"},[_c('icon-com',{attrs:{"name":"circle","size":"large","color":_vm.feedGroup.color}})],1),_vm._v(" "),_c('div',{staticClass:"dashboardHeader-feedName"},[_vm._v("\n      "+_vm._s(_vm.feedGroup.plural)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"dashboardHeader-addFeedGroupHolder"},[_c('button-com',{attrs:{"iconName":"list-add","iconSize":"small","text":'Add new ' + _vm.feedGroup.singular},nativeOn:{"click":function($event){_vm.addFeedGroup($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"dashboardHeader-manageFeedHolder"},[_c('div',{staticClass:"dashboardHeader-manageFeedButtonHolder"},[_c('button-com',{staticClass:"bm-ghost bm-onlyIcon",attrs:{"iconName":_vm.feedGroupPublic ? 'public' : 'private',"iconSize":"large","iconCircleColor":"#E0E0E0","tooltip":_vm.feedGroupPublic ? "Make Private" : "Make Public"},nativeOn:{"click":function($event){_vm.toggleFeedGroupPublic($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"dashboardHeader-manageFeedButtonHolder"},[_c('button-com',{staticClass:"bm-ghost bm-onlyIcon",attrs:{"iconName":"settings","iconSize":"large","iconCircleColor":"#E0E0E0","tooltip":"Settings"},nativeOn:{"click":function($event){_vm.goTo('/changeCurrentFeed')}}})],1),_vm._v(" "),_c('div',{staticClass:"dashboardHeader-manageFeedButtonHolder"},[_c('button-com',{staticClass:"bm-ghost bm-onlyIcon",attrs:{"iconName":"delete","iconSize":"large","iconCircleColor":"#E0E0E0","tooltip":"Delete"},nativeOn:{"click":function($event){_vm.deleteFeedGroup($event)}}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("PO8x");
function injectStyle (ssrContext) {
  __webpack_require__("Ecmc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MYFT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"htmlInput"},[_c('div',{staticClass:"htmlInput-name"},[_vm._v(_vm._s(_vm.name)+" - "+_vm._s(_vm.textLength))]),_vm._v(" "),_c('div',{staticClass:"htmlInput-field"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"rows":"8","cols":"80"},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MYJi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MoaA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Image_vue__ = __webpack_require__("20Wp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2498b0c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Image_vue__ = __webpack_require__("Y6AQ");
function injectStyle (ssrContext) {
  __webpack_require__("QqHo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Image_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2498b0c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_reactive_cookie__ = __webpack_require__("YvJ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_reactive_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_reactive_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sass_app_sass__ = __webpack_require__("v663");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sass_app_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__sass_app_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sass_iconfont_scss__ = __webpack_require__("tkif");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sass_iconfont_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__sass_iconfont_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_uploadcare__ = __webpack_require__("3K3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__globalComponents_Icon__ = __webpack_require__("5nB1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__globalComponents_Button__ = __webpack_require__("ax5j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__globalComponents_ContentGroup__ = __webpack_require__("EgbF");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









// Global components





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__sass_app_sass___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__sass_iconfont_scss___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_reactive_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// Global components
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('uploadcare-com', __WEBPACK_IMPORTED_MODULE_8_vue_uploadcare__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('icon-com', __WEBPACK_IMPORTED_MODULE_9__globalComponents_Icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('button-com', __WEBPACK_IMPORTED_MODULE_10__globalComponents_Button__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('contentgroup-com', __WEBPACK_IMPORTED_MODULE_11__globalComponents_ContentGroup__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  strict: true,
  state: {
    changesFound: false,
    userInfo: {
      name: '',
      organisation: ''
    },
    feeds: [],
    currentFeed: null
  },
  mutations: {
    userInfo: function userInfo(state, _ref) {
      var name = _ref.name,
          organisation = _ref.organisation;

      var userInfo = state.userInfo;

      userInfo.name = name;
      userInfo.organisation = organisation;
    },
    wipeUserInfo: function wipeUserInfo(state) {
      var userInfo = state.userInfo;

      userInfo.name = '';
      userInfo.organisation = '';
    },
    feeds: function feeds(state, _feeds) {
      state.feeds = _feeds;
    },
    addNewType: function addNewType(state, typeData) {
      state.feeds.push(typeData);
    },
    updateFeedHeader: function updateFeedHeader(state, _ref2) {
      var value = _ref2.value,
          key = _ref2.key,
          feedGroupIndex = _ref2.feedGroupIndex,
          feedIndex = _ref2.feedIndex;

      var feeds = state.feeds;
      var feedGroup = feeds[feedGroupIndex];
      var feed = feedGroup[feedIndex];
      feed[key] = value;
    },
    updateFeedGroupHeader: function updateFeedGroupHeader(state, _ref3) {
      var value = _ref3.value,
          key = _ref3.key,
          feedGroupIndex = _ref3.feedGroupIndex,
          feedIndex = _ref3.feedIndex;

      var feeds = state.feeds;
      var feedGroup = feeds[feedGroupIndex];
      var feed = feedGroup[feedIndex];
      var input = feed[0];
      input[key] = value;
    },
    updateDataType: function updateDataType(state, _ref4) {
      var property = _ref4.property,
          value = _ref4.value,
          index = _ref4.index;

      state.feeds[state.currentFeed][0].template[index][property] = value;
    },
    addDataType: function addDataType(state) {
      state.feeds[state.currentFeed][0].template.push({
        name: '',
        type: 'text'
      });
    },
    deleteDataType: function deleteDataType(state, inIndex) {
      state.feeds[state.currentFeed][0].template.splice(inIndex, 1);
    },
    deleteFeedGroup: function deleteFeedGroup(state, _ref5) {
      var feedGroupIndex = _ref5.feedGroupIndex;

      state.feeds.splice(feedGroupIndex, 1);
    },
    toggleFeedGroupPublic: function toggleFeedGroupPublic(state, _ref6) {
      var feedGroupIndex = _ref6.feedGroupIndex,
          isPublic = _ref6.isPublic;

      state.feeds[feedGroupIndex][0].public = isPublic;
    },
    deleteFeed: function deleteFeed(state, _ref7) {
      var feedGroupIndex = _ref7.feedGroupIndex,
          feedIndex = _ref7.feedIndex;

      state.feeds[feedGroupIndex].splice(feedIndex, 1);
    },
    moveTo: function moveTo(state, _ref8) {
      var feedGroupIndex = _ref8.feedGroupIndex,
          oldIndex = _ref8.oldIndex,
          newIndex = _ref8.newIndex;

      var feed = state.feeds[feedGroupIndex];

      while (oldIndex < 0) {
        oldIndex += feed.length;
      }
      while (newIndex < 0) {
        newIndex += feed.length;
      }
      if (newIndex >= feed.length) {
        var k = newIndex - feed.length + 1;
        while (k--) {
          feed.push(undefined);
        }
      }
      feed.splice(newIndex, 0, feed.splice(oldIndex, 1)[0]);
    },
    addFeedGroup: function addFeedGroup(state, _ref9) {
      var feedGroupIndex = _ref9.feedGroupIndex,
          template = _ref9.template;

      var name = {
        name: 'name',
        type: 'name',
        value: '',
        visible: true,
        public: true
      };

      var feed = template.map(function (_ref10) {
        var name = _ref10.name,
            type = _ref10.type;

        var value = void 0;

        switch (type) {
          case 'list':
            value = [];
            break;
          case 'number':
            value = 0;
            break;
          default:
            value = '';
            break;
        }

        return {
          name: name,
          type: type,
          value: value
        };
      });

      feed.splice(0, 0, name);
      state.feeds[feedGroupIndex].splice(1, 0, feed);
    },
    updateInput: function updateInput(state, _ref11) {
      var value = _ref11.value,
          key = _ref11.key,
          feedGroupIndex = _ref11.feedGroupIndex,
          feedIndex = _ref11.feedIndex,
          inputIndex = _ref11.inputIndex;

      var feeds = state.feeds;
      var feedGroup = feeds[feedGroupIndex];
      var feed = feedGroup[feedIndex];
      var input = feed[inputIndex];
      input[key] = value;
    },
    currentFeed: function currentFeed(state, index) {
      state.currentFeed = index;
    },
    changesFound: function changesFound(state, changed) {
      state.changesFound = changed;
    }
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: store,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Nkxv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NtoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: '',
      password: ''
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      this.$http.post('http://api.lootbox.se/login', {
        username: this.username,
        password: this.password
      }, {
        emulateJSON: true,
        withCredentials: true
      }).then(function (_ref) {
        var body = _ref.body;

        _this.username = '';
        _this.password = '';

        if (!body) {
          return;
        }

        _this.$store.commit({
          type: 'userInfo',
          name: body.name,
          organisation: body.organisation
        });

        if (body.feeds.length) {
          _this.$store.commit('feeds', body.feeds);
        }

        _this.$store.commit('currentFeed', 0);
      }, function () {
        console.log('Fail!');
      });
    }
  }
});

/***/ }),

/***/ "NuOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Text_vue__ = __webpack_require__("tsRJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f88defc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Text_vue__ = __webpack_require__("2NdS");
function injectStyle (ssrContext) {
  __webpack_require__("n+xM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Text_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f88defc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nz39":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['iconName', 'iconSize', 'iconColor', 'iconCircleColor', 'text', 'tooltip'],
  data: function data() {
    return {
      pressed: false,
      hovering: false
    };
  },

  methods: {
    press: function press() {
      this.pressed = true;
    },
    release: function release() {
      this.pressed = false;
    },
    hover: function hover(_hover) {
      this.hovering = _hover;

      if (!_hover) {
        this.release();
      }
    }
  }
});

/***/ }),

/***/ "OuQA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listInput"},[_c('div',{staticClass:"listInput-header"},[_c('div',{staticClass:"listInput-name"},[_vm._v(_vm._s(_vm.name)+" - "+_vm._s(_vm.value.length))]),_vm._v(" "),_c('div',{staticClass:"listInput-buttonHolder"},[_c('button-com',{staticClass:"bm-ghost bm-onlyIcon",attrs:{"iconName":"list-add","iconSize":"large","iconCircleColor":"#F0F0F0","tooltip":"Lägg till"},nativeOn:{"click":function($event){_vm.addItem($event)}}})],1)]),_vm._v(" "),_vm._l((_vm.value),function(item,index){return _c('div',{staticClass:"listInput-item"},[_c('div',{staticClass:"listInput-inputButtonHolder"},[_c('button-com',{staticClass:"bm-ghost bm-onlyIcon",attrs:{"iconName":"delete","tooltip":"Delete"},nativeOn:{"click":function($event){_vm.removeItem(index)}}})],1),_vm._v(" "),_c('input',{attrs:{"type":"text","placeholder":"..."},domProps:{"value":item},on:{"input":function($event){_vm.updateItem({$event: $event, index: index})}}})])}),_vm._v(" "),(_vm.value.length === 0)?_c('div',{staticClass:"listInput-empty"},[_vm._v("\n    Inga "+_vm._s(_vm.name)+" har lagts till\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PDec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataTypes"},[_c('div',{staticClass:"dataTypes-header"},[_c('div',{staticClass:"dataTypes-headerText"},[_vm._v("\n      Datatypes\n    ")]),_vm._v(" "),_c('div',{staticClass:"dataTypes-buttonHolder"},[_c('button-com',{attrs:{"iconName":"list-add","text":"Add New Datatype"},nativeOn:{"click":function($event){_vm.addDataType($event)}}})],1)]),_vm._v(" "),_vm._l((_vm.dataTypes),function(dataType,index){return _c('div',{staticClass:"dataTypes-dataType"},[_c('div',{staticClass:"dataTypes-inputButtonHolder"},[_c('div',{staticClass:"dataTypes-selectedDataType noUserSelect"},[_c('select',{domProps:{"value":dataType.type},on:{"input":function($event){_vm.updateType(index, $event)}}},_vm._l((_vm.existingDataTypes),function(existingDataType){return _c('option',{domProps:{"value":existingDataType.value}},[_vm._v("\n            "+_vm._s(existingDataType.text)+"\n          ")])}))]),_vm._v(" "),_c('button-com',{staticClass:"bm-ghost bm-onlyIcon",attrs:{"iconName":"delete","tooltip":"Delete"},nativeOn:{"click":function($event){_vm.deleteDataType(index)}}})],1),_vm._v(" "),_c('div',{staticClass:"dataTypes-number"},[_c('icon-com',{attrs:{"text":index + 1,"size":"iconSize"}})],1),_vm._v(" "),_c('input',{staticClass:"dataTypes-input",attrs:{"type":"text","placeholder":"..."},domProps:{"value":dataType.name},on:{"input":function($event){_vm.updateText(index, $event)}}})])}),_vm._v(" "),(_vm.dataTypes.length === 0)?_c('div',{staticClass:"dataTypes-empty"},[_vm._v("\n    No datatypes has been added\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PO8x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(_vm.name)?_c('navigation-com'):_vm._e(),_vm._v(" "),(_vm.name)?_c('router-view',{staticClass:"wrapper"}):_vm._e(),_vm._v(" "),(!_vm.name && _vm.triedRestoreSession)?_c('login-view'):_vm._e(),_vm._v(" "),(!_vm.triedRestoreSession)?_c('div',{staticClass:"app-loader"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "POLT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTypes_vue__ = __webpack_require__("qGYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6382099d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTypes_vue__ = __webpack_require__("PDec");
function injectStyle (ssrContext) {
  __webpack_require__("urME")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTypes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6382099d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTypes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PUcz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QCOa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addNewFeed"},[_c('addnewtypeheader-com',{attrs:{"plural":_vm.plural,"singular":_vm.singular,"dataTypes":_vm.dataTypes}}),_vm._v(" "),_c('contentgroup-com',[_c('div',{staticClass:"addNewFeed-column"},[_c('div',{staticClass:"addNewFeed-name"},[_vm._v("Plural "),_c('span',[_vm._v("- ex. Pages")])]),_vm._v(" "),_c('div',{staticClass:"addNewFeed-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.plural),expression:"plural"}],attrs:{"type":"text","placeholder":"..."},domProps:{"value":(_vm.plural)},on:{"input":function($event){if($event.target.composing){ return; }_vm.plural=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"addNewFeed-divider"}),_vm._v(" "),_c('div',{staticClass:"addNewFeed-column"},[_c('div',{staticClass:"addNewFeed-name"},[_vm._v("Singular "),_c('span',[_vm._v("- ex. Page")])]),_vm._v(" "),_c('div',{staticClass:"addNewFeed-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.singular),expression:"singular"}],attrs:{"type":"text","placeholder":"..."},domProps:{"value":(_vm.singular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.singular=$event.target.value}}})])])]),_vm._v(" "),_c('contentgroup-com',{attrs:{"marginBottom":"300"}},[_c('datatypes-com',{attrs:{"currentDataTypes":_vm.dataTypes},on:{"dataTypes":function($event){_vm.setDataTypes($event)}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QHzf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QSVP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QqHo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RUXU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RiwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['plural', 'singular', 'dataTypes'],
  computed: {
    feeds: function feeds() {
      return this.$store.state.feeds;
    },
    currentFeed: function currentFeed() {
      return this.$store.state.currentFeed;
    }
  },
  methods: {
    updateFeedHeader: function updateFeedHeader(key, value) {
      this.$store.commit({
        type: 'updateFeedHeader',
        key: key,
        value: value,
        feedGroupIndex: this.currentFeed,
        feedIndex: 0
      });
    },
    save: function save() {
      var _this = this;

      this.updateFeedHeader('plural', this.plural);
      this.updateFeedHeader('singular', this.singular);
      this.updateFeedHeader('template', this.dataTypes);
      this.$http.post('http://api.lootbox.se/saveChanges', {
        feeds: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.feeds)
      }, {
        emulateJSON: true,
        withCredentials: true
      }).then(function () {
        _this.$router.push('/');
      }, function () {
        console.log('Fail!');
      });
    }
  }
});

/***/ }),

/***/ "SQJa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addNewTypeHeader"},[_c('div',{staticClass:"addNewTypeHeader-saveHolder"},[_c('button-com',{staticClass:"bm-confirm",attrs:{"iconName":"check","iconSize":"small","text":"Save"},nativeOn:{"click":function($event){_vm.save($event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SoBG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_Input__ = __webpack_require__("gcDA");
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__inputs_Input__["a" /* default */],
  props: ['name']
});

/***/ }),

/***/ "THEr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UfVl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentGroup",style:({'margin-bottom' : _vm.marginBottom + 'px', 'margin-top' : _vm.marginTop + 'px'})},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XfQv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginContainer"},[_c('contentgroup-com',[_c('div',{staticClass:"login"},[_c('div',{staticClass:"login-fields"},[_c('div',{staticClass:"login-input"},[_c('div',{staticClass:"login-inputLabel"},[_vm._v("\n            Username\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"type":"text"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"login-fieldsDivider"}),_vm._v(" "),_c('div',{staticClass:"login-input"},[_c('div',{staticClass:"login-inputLabel"},[_vm._v("\n            Password\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"login-button"},[_c('button-com',{attrs:{"text":"Login"},nativeOn:{"click":function($event){_vm.login($event)}}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y6AQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imageInput"},[_c('div',{staticClass:"imageInput-name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('div',{staticClass:"imageInput-field"},[_c('img',{staticClass:"imageInput-image",attrs:{"src":_vm.value}}),_vm._v(" "),_c('uploadcare-com',{attrs:{"url":_vm.value},on:{"update:url":function($event){_vm.value=$event}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YGI3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("r5yU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8dfac26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("OuQA");
function injectStyle (ssrContext) {
  __webpack_require__("MYJi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8dfac26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerViews_Dashboard__ = __webpack_require__("kYQT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerViews_Settings__ = __webpack_require__("jhlV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routerViews_Test__ = __webpack_require__("eQ+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routerViews_AddNewFeed__ = __webpack_require__("ryq9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routerViews_ChangeCurrentFeed__ = __webpack_require__("zTyo");









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__routerViews_Dashboard__["a" /* default */]
  }, {
    path: '/addNewFeed',
    component: __WEBPACK_IMPORTED_MODULE_5__routerViews_AddNewFeed__["a" /* default */]
  }, {
    path: '/changeCurrentFeed',
    component: __WEBPACK_IMPORTED_MODULE_6__routerViews_ChangeCurrentFeed__["a" /* default */]
  }, {
    path: '/settings',
    component: __WEBPACK_IMPORTED_MODULE_3__routerViews_Settings__["a" /* default */]
  }, {
    path: '/test',
    component: __WEBPACK_IMPORTED_MODULE_4__routerViews_Test__["a" /* default */]
  }]
}));

/***/ }),

/***/ "ax5j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__("Nz39");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e10bc51_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__("j3i+");
function injectStyle (ssrContext) {
  __webpack_require__("Nkxv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e10bc51_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bVQ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      active: true,
      addNewFeedPage: false
    };
  },

  computed: {
    feeds: function feeds() {
      return this.$store.state.feeds;
    },
    currentFeed: function currentFeed() {
      return this.$store.state.currentFeed;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.addNewFeedPage = to.path === '/addNewFeed';
    }
  },
  mounted: function mounted() {
    this.addNewFeedPage = this.$router.history.current.path === '/addNewFeed';
  },

  methods: {
    goTo: function goTo(link) {
      var _this = this;

      this.$http.post('http://api.lootbox.se/addType', {
        plural: '',
        singular: '',
        dataTypes: []
      }, {
        emulateJSON: true,
        withCredentials: true
      }).then(function (_ref) {
        var body = _ref.body;

        _this.$store.commit('addNewType', body);
        _this.changeFeedTo(_this.feeds.length - 1);
        _this.$router.push('/addNewFeed');
      }, function () {
        console.log('Fail!');
      });
    },
    changeFeedTo: function changeFeedTo(index) {
      this.$router.push('/');
      this.$store.commit('currentFeed', index);
    },
    logout: function logout() {
      var _this2 = this;

      this.$router.push('/');
      this.$http.get('http://api.lootbox.se/logout', {
        emulateJSON: true,
        withCredentials: true
      }).then(function (_ref2) {
        var body = _ref2.body;

        _this2.$store.commit('wipeUserInfo');
      }, function () {
        console.log('Fail!');
      });
    }
  }
});

/***/ }),

/***/ "bsJx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[(!_vm.feeds.length)?_c('div',{staticClass:"dashboard-overview"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.feeds),function(feedGroup,feedGroupIndex){return (feedGroupIndex === _vm.currentFeed)?_c('div',{staticClass:"dashboard-feeds"},[(feedGroup)?[(!Array.isArray(feedGroup[0]))?_c('dashboardheader-com',{attrs:{"feedGroup":feedGroup[0],"feedGroupIndex":feedGroupIndex}}):_vm._e(),_vm._v(" "),_vm._l((feedGroup),function(feed,feedIndex){return (Array.isArray(feed))?_c('div',{staticClass:"feedGroup",class:{'bm-first': feedIndex === 1, 'bm-last': feedIndex === feedGroup.length - 1}},[_c('div',{staticClass:"feedGroup-area"}),_vm._v(" "),_c('div',{staticClass:"feedGroup-sort"},[_c('div',{staticClass:"feedGroup-sortUp",on:{"click":function($event){_vm.moveUp(feedIndex)}}},[_c('icon-com',{attrs:{"name":"arrow-up","size":"small"}})],1),_vm._v(" "),_c('div',{staticClass:"feedGroup-sortDown",on:{"click":function($event){_vm.moveDown(feedIndex)}}},[_c('icon-com',{attrs:{"name":"arrow-down","size":"small"}})],1)]),_vm._v(" "),_vm._l((feed),function(input,inputIndex){return (Array.isArray(feed) && feed[0].visible || input.name === 'name')?_c('div',{staticClass:"feedGroup-feed",class:{'m-header' : input.name === 'name'}},[(input.name === 'name')?_c('feedgroupheader-com',{attrs:{"feedGroupIndex":feedGroupIndex,"feedIndex":feedIndex}}):_vm._e(),_vm._v(" "),(input.type !== 'name')?_c(input.type + '-input',{tag:"component",attrs:{"feedGroupIndex":feedGroupIndex,"feedIndex":feedIndex,"inputIndex":inputIndex,"name":input.name,"value":input.value}}):_vm._e()],1):_vm._e()})],2):_vm._e()}),_vm._v(" "),_c('dashboardfooter-com',{attrs:{"feedId":feedGroup[0].id}})]:_vm._e()],2):_vm._e()})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-gettingStarted"},[_c('img',{staticClass:"dashboard-leftArrow",attrs:{"src":__webpack_require__("cQu0")}}),_vm._v("\n      Click on \"Add New Feed\" to get started\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bwGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__("bVQ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40aa51d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__("jBJj");
function injectStyle (ssrContext) {
  __webpack_require__("7C1O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40aa51d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cQu0":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "dtyd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e1wv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"changeCurrentFeed"},[_c('div',{staticClass:"updateTypeHeader"},[_c('div',{staticClass:"updateTypeHeader-saveHolder"},[_c('button-com',{staticClass:"bm-confirm",attrs:{"iconName":"check","iconSize":"small","text":"Update"},nativeOn:{"click":function($event){_vm.update($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"updateTypeHeader-closeHolder"},[_c('button-com',{staticClass:"bm-ghost bm-onlyIcon",attrs:{"iconName":"close","iconSize":"large","iconColor":"#D0D0D0","iconCircleColor":"#D0D0D0","tooltip":"Cancel"},nativeOn:{"click":function($event){_vm.cancel($event)}}})],1)]),_vm._v(" "),_c('contentgroup-com',[_c('div',{staticClass:"changeCurrentFeed-column"},[_c('div',{staticClass:"changeCurrentFeed-name"},[_vm._v("Plural "),_c('span',[_vm._v("- ex. Pages")])]),_vm._v(" "),_c('div',{staticClass:"changeCurrentFeed-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.plural),expression:"plural"}],attrs:{"type":"text","placeholder":"..."},domProps:{"value":(_vm.plural)},on:{"input":function($event){if($event.target.composing){ return; }_vm.plural=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"changeCurrentFeed-divider"}),_vm._v(" "),_c('div',{staticClass:"changeCurrentFeed-column"},[_c('div',{staticClass:"changeCurrentFeed-name"},[_vm._v("Singular "),_c('span',[_vm._v("- ex. Page")])]),_vm._v(" "),_c('div',{staticClass:"changeCurrentFeed-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.singular),expression:"singular"}],attrs:{"type":"text","placeholder":"..."},domProps:{"value":(_vm.singular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.singular=$event.target.value}}})])])]),_vm._v(" "),_c('contentgroup-com',{attrs:{"marginBottom":"300"}},[_c('datatypes-com',{attrs:{"currentDataTypes":_vm.dataTypes},on:{"dataTypes":function($event){_vm.setDataTypes($event)}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eQ+J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Test_vue__ = __webpack_require__("ftHF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51a9823a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Test_vue__ = __webpack_require__("9nuk");
function injectStyle (ssrContext) {
  __webpack_require__("tW/y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Test_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51a9823a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Test_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fZ+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AddNewTypeHeader__ = __webpack_require__("mirS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTypes__ = __webpack_require__("POLT");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AddnewtypeheaderCom: __WEBPACK_IMPORTED_MODULE_1__components_AddNewTypeHeader__["a" /* default */],
    DatatypesCom: __WEBPACK_IMPORTED_MODULE_2__components_DataTypes__["a" /* default */]
  },
  computed: {
    saveable: function saveable() {
      return !!this.plural && !!this.singular && !!this.dataTypes.length;
    },
    feeds: function feeds() {
      return this.$store.state.feeds;
    },
    feed: function feed() {
      return this.$store.state.feeds[this.currentFeed];
    },
    currentFeed: function currentFeed() {
      return this.$store.state.currentFeed;
    }
  },
  methods: {
    updateFeedHeader: function updateFeedHeader(key, value) {
      this.$store.commit({
        type: 'updateFeedHeader',
        key: key,
        value: value,
        feedGroupIndex: this.currentFeed,
        feedIndex: 0
      });
    },
    cancel: function cancel() {
      this.$router.push('/');
    },
    update: function update() {
      var _this = this;

      this.updateFeedHeader('plural', this.plural);
      this.updateFeedHeader('singular', this.singular);
      this.updateFeedHeader('template', this.dataTypes);
      this.$http.post('http://api.lootbox.se/saveChanges', {
        feeds: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.feeds)
      }, {
        emulateJSON: true,
        withCredentials: true
      }).then(function () {
        _this.$router.push('/');
      }, function () {
        console.log('Fail!');
      });
    },
    setDataTypes: function setDataTypes(dataTypes) {
      this.dataTypes = dataTypes;
    }
  },
  data: function data() {
    return {
      plural: '',
      singular: '',
      dataTypes: []
    };
  },
  created: function created() {
    this.plural = this.feed[0].plural;
    this.singular = this.feed[0].singular;
    this.dataTypes = this.feed[0].template;
  }
});

/***/ }),

/***/ "ftHF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      bildspel: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$http.get('http://api.lootbox.se/v1/feed/5a15b2f0ba79b', {
      emulateJSON: true,
      withCredentials: true
    }).then(function (_ref) {
      var body = _ref.body;

      _this.bildspel = body;
    }, function () {
      console.log('Fail!');
    });
  }
});

/***/ }),

/***/ "g+qg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['feedGroup', 'feedGroupIndex'],
  computed: {
    feedGroupPublic: function feedGroupPublic() {
      return this.$store.state.feeds[this.feedGroupIndex][0].public;
    },
    feeds: function feeds() {
      return this.$store.state.feeds;
    },
    currentFeed: function currentFeed() {
      return this.$store.state.currentFeed;
    }
  },
  methods: {
    goTo: function goTo(link) {
      this.$router.push(link);
    },
    deleteFeedGroup: function deleteFeedGroup() {
      var _this = this;

      var shouldDelete = confirm('Are you sure you want to delete "' + this.feedGroup.plural + '" ?');
      if (shouldDelete) {
        this.$store.commit({
          type: 'deleteFeedGroup',
          feedGroupIndex: this.feedGroupIndex
        });

        this.$http.post('http://api.lootbox.se/deleteType', {
          id: this.feedGroup.id
        }, {
          emulateJSON: true,
          withCredentials: true
        }).then(function () {
          _this.$store.commit('currentFeed', _this.feeds.length - 1);
        });
      }
    },
    updateTemplate: function updateTemplate() {
      this.$store.commit({
        type: 'updateTemplate',
        feedGroupIndex: this.feedGroupIndex
      });
    },
    addFeedGroup: function addFeedGroup() {
      this.$store.commit({
        type: 'addFeedGroup',
        feedGroupIndex: this.feedGroupIndex,
        template: this.feedGroup.template
      });
    },
    toggleFeedGroupPublic: function toggleFeedGroupPublic() {
      this.$store.commit({
        type: 'toggleFeedGroupPublic',
        feedGroupIndex: this.feedGroupIndex,
        isPublic: !this.feedGroupPublic
      });
    }
  }
});

/***/ }),

/***/ "gcDA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Input_vue__ = __webpack_require__("q1pH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ij5H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Html_vue__ = __webpack_require__("vBdP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3742327a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Html_vue__ = __webpack_require__("MYFT");
function injectStyle (ssrContext) {
  __webpack_require__("KHUw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Html_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3742327a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Html_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j3i+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button noUserSelect",class:{
    'bm-pressed' : _vm.pressed,
    'bm-showTooltip' : _vm.hovering
  },on:{"mousedown":_vm.press,"touchstart":_vm.press,"touchend":_vm.release,"mouseup":_vm.release,"mouseleave":function($event){_vm.hover(false)},"mouseenter":function($event){_vm.hover(true)}}},[(_vm.tooltip)?_c('div',{staticClass:"button-tooltip"},[_vm._v(_vm._s(_vm.tooltip))]):_vm._e(),_vm._v(" "),(_vm.iconName)?_c('icon-com',{attrs:{"name":_vm.iconName,"size":_vm.iconSize,"color":_vm.iconColor,"circleColor":_vm.iconCircleColor}}):_vm._e(),_vm._v(" "),(_vm.text)?_c('div',{staticClass:"button-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jAnk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Usernav__ = __webpack_require__("zkCS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['feedId'],
  components: {
    UsernavCom: __WEBPACK_IMPORTED_MODULE_0__components_Usernav__["a" /* default */]
  },
  methods: {
    goTo: function goTo(link) {
      var win = window.open(link, '_blank');
      win.focus();
    }
  }
});

/***/ }),

/***/ "jBJj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation noUserSelect"},[(_vm.active)?_c('div',{staticClass:"navigation-panel"},[_c('div',{staticClass:"navigation-panelGroup m-noBorder"},[_c('div',{staticClass:"navigation-panelItem m-bottom20"},[_c('div',{staticClass:"navigation-panelItemIcon"},[_c('icon-com',{attrs:{"name":"share"}})],1),_vm._v(" "),_c('div',{staticClass:"navigation-panelItemText"},[_vm._v("Feeds")])]),_vm._v(" "),_vm._l((_vm.feeds),function(feedGroup,feedGroupIndex){return _vm._l((feedGroup),function(feed){return (!Array.isArray(feed))?_c('div',{staticClass:"navigation-panelItem m-bottom5 m-clickable",class:{ 'm-active' : _vm.currentFeed === feedGroupIndex },on:{"click":function($event){_vm.changeFeedTo(feedGroupIndex)}}},[_c('div',{staticClass:"navigation-panelItemIcon",style:({ 'color' : feed.color })},[_c('icon-com',{attrs:{"name":(feedGroup[0].public) ? 'public' : 'private',"size":"small"}})],1),_vm._v(" "),_c('div',{staticClass:"navigation-panelItemText"},[(!feed.plural)?_c('span',[_vm._v("...")]):_vm._e(),_vm._v(_vm._s(feed.plural))]),_vm._v(" "),_c('div',{staticClass:"navigation-panelFeedCount"},[_c('icon-com',{attrs:{"text":feedGroup.length - 1}})],1)]):_vm._e()})}),_vm._v(" "),_c('div',{staticClass:"navigation-panelItem m-top5 m-clickable",class:{'m-highlight' : !_vm.feeds.length, 'm-disabled' : _vm.addNewFeedPage},on:{"click":_vm.goTo}},[_c('div',{staticClass:"navigation-panelItemIcon"},[_c('icon-com',{attrs:{"name":"plus"}})],1),_vm._v(" "),_c('div',{staticClass:"navigation-panelItemText"},[_vm._v("Add New Feed")])])],2),_vm._v(" "),_c('div',{staticClass:"navigation-panelGroup m-last"},[_c('div',{staticClass:"navigation-panelItem m-clickable",on:{"click":_vm.logout}},[_c('div',{staticClass:"navigation-panelItemIcon"},[_c('icon-com',{attrs:{"name":"logout"}})],1),_vm._v(" "),_c('div',{staticClass:"navigation-panelItemText"},[_vm._v("Logout")])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jVck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"hidden"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jhlV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("ylDi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41c2fd18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("A7MZ");
function injectStyle (ssrContext) {
  __webpack_require__("QSVP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41c2fd18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jrIX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kU7T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardFooter_vue__ = __webpack_require__("jAnk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8562906_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardFooter_vue__ = __webpack_require__("LheX");
function injectStyle (ssrContext) {
  __webpack_require__("LArW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8562906_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kYQT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("7XbA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a7de13_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("bsJx");
function injectStyle (ssrContext) {
  __webpack_require__("3IVD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a7de13_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ktta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AddNewTypeHeader__ = __webpack_require__("mirS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataTypes__ = __webpack_require__("POLT");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AddnewtypeheaderCom: __WEBPACK_IMPORTED_MODULE_0__components_AddNewTypeHeader__["a" /* default */],
    DatatypesCom: __WEBPACK_IMPORTED_MODULE_1__components_DataTypes__["a" /* default */]
  },
  methods: {
    setDataTypes: function setDataTypes(dataTypes) {
      this.dataTypes = dataTypes;
    }
  },
  computed: {
    feeds: function feeds() {
      return this.$store.state.feeds;
    },
    feed: function feed() {
      var currentFeed = this.$store.state.currentFeed;
      return this.$store.state.feeds[currentFeed];
    }
  },
  data: function data() {
    return {
      plural: '',
      singular: '',
      dataTypes: []
    };
  },
  created: function created() {
    this.plural = this.feed[0].plural;
    this.singular = this.feed[0].singular;
    this.dataTypes = this.feed[0].template;
  }
});

/***/ }),

/***/ "lmfZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("NtoT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3d9c19e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("XfQv");
function injectStyle (ssrContext) {
  __webpack_require__("RUXU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3d9c19e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mJ7H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mirS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddNewTypeHeader_vue__ = __webpack_require__("RiwL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e19f770_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddNewTypeHeader_vue__ = __webpack_require__("SQJa");
function injectStyle (ssrContext) {
  __webpack_require__("jrIX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddNewTypeHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e19f770_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddNewTypeHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n+xM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ndKc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      savingChanges: false
    };
  },

  computed: {
    feeds: function feeds() {
      return this.$store.state.feeds;
    },
    currentFeed: function currentFeed() {
      return this.$store.state.currentFeed;
    },
    name: function name() {
      return this.$store.state.userInfo.name;
    },
    changesFound: function changesFound() {
      return this.$store.state.changesFound;
    },
    saveStateText: function saveStateText() {
      return this.savingChanges ? 'Saving...' : 'Save';
    }
  },
  methods: {
    restore: function restore() {
      var _this = this;

      var restore = confirm('Är du säker på att du vill återställa dina ändringar?');

      if (!restore) {
        return;
      }

      this.$http.get('http://api.lootbox.se/restoresession', {
        emulateJSON: true,
        withCredentials: true
      }).then(function (_ref) {
        var body = _ref.body;

        if (!body) {
          return;
        }

        if (body.feeds.length) {
          _this.$store.commit('feeds', body.feeds);
        }

        _this.saveChanges(0);
      }, function () {
        console.log('Fail!');
      });
    },
    saveChanges: function saveChanges(time) {
      var _this2 = this;

      this.savingChanges = true;
      this.$http.post('http://api.lootbox.se/saveChanges', {
        feeds: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.feeds)
      }, {
        emulateJSON: true,
        withCredentials: true
      }).then(function () {
        setTimeout(function () {
          _this2.$store.commit('changesFound', false);
          _this2.savingChanges = false;
        }, time);
      }, function () {
        console.log('Fail!');
      });
    }
  }
});

/***/ }),

/***/ "nhVN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "plZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconHolder",class:(_vm.size) ? ("bm-" + _vm.size) : '',style:({
    'border-color' : _vm.circleColor,
    'color' : _vm.color
  })},[(!_vm.text && _vm.name)?_c('span',{class:'icon-' + _vm.name}):_vm._e(),_vm._v(" "),(_vm.text !== '')?_c('div',{staticClass:"iconHolder-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q1pH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['feedGroupIndex', 'feedIndex', 'inputIndex'],
  methods: {
    getInput: function getInput(key) {
      var feeds = this.$store.state.feeds;
      var feedGroup = feeds[this.feedGroupIndex];
      var feed = feedGroup[this.feedIndex];
      var input = feed[this.inputIndex];
      return input[key];
    },
    updateInput: function updateInput(key, value) {
      this.$store.commit({
        type: 'updateInput',
        key: key,
        value: value,
        feedGroupIndex: this.feedGroupIndex,
        feedIndex: this.feedIndex,
        inputIndex: this.inputIndex
      });
    }
  },
  computed: {
    value: {
      get: function get() {
        return this.getInput('value');
      },
      set: function set(value) {
        this.updateInput('value', value);
      }
    }
  }
});

/***/ }),

/***/ "qGYM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['currentDataTypes'],
  computed: {
    feeds: function feeds() {
      return this.$store.state.feeds;
    }
  },
  data: function data() {
    return {
      dataTypes: [],
      existingDataTypes: [{ text: 'Text', value: 'text' }, { text: 'Nummer', value: 'number' }, { text: 'Lista', value: 'list' }, { text: 'Bild', value: 'image' }, { text: 'Html', value: 'html' }]
    };
  },

  watch: {
    dataTypes: function dataTypes() {
      this.$emit('dataTypes', this.dataTypes);
    }
  },
  mounted: function mounted() {
    this.dataTypes = this.currentDataTypes || [];
  },

  methods: {
    updateText: function updateText(index, e) {
      this.$store.commit({
        type: 'updateDataType',
        property: 'name',
        value: e.target.value,
        index: index
      });
    },
    updateType: function updateType(index, e) {
      this.$store.commit({
        type: 'updateDataType',
        property: 'type',
        value: e.target.value,
        index: index
      });
    },
    addDataType: function addDataType() {
      this.$store.commit('addDataType');
    },
    deleteDataType: function deleteDataType(index) {
      this.$store.commit('deleteDataType', index);
    }
  }
});

/***/ }),

/***/ "qlDh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userNav noUserSelect"},[_c('div',{staticClass:"userNav-nav",class:{'m-visible': _vm.changesFound}},[_c('div',{staticClass:"userNav-space"}),_vm._v(" "),_c('button-com',{staticClass:"bm-confirm",class:{'bm-loading': _vm.savingChanges},attrs:{"iconName":"check","iconSize":"small","text":_vm.saveStateText},nativeOn:{"click":function($event){_vm.saveChanges(2000)}}}),_vm._v(" "),_c('div',{staticClass:"userNav-space"}),_vm._v("\n    or\n    "),_c('div',{staticClass:"userNav-space"}),_vm._v(" "),_c('button-com',{staticClass:"bm-cancel",attrs:{"iconName":"settings_backup_restore","iconSize":"small","text":"Restore"},nativeOn:{"click":function($event){_vm.restore($event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r5yU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray__ = __webpack_require__("7nRM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inputs_Input__ = __webpack_require__("gcDA");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_1__inputs_Input__["a" /* default */],
  props: ['name'],
  methods: {
    updateItem: function updateItem(_ref) {
      var $event = _ref.$event,
          index = _ref.index;

      var _value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default()(this.value),
          value = _value.slice(0);

      value[index] = $event.target.value;
      this.updateInput('value', value);
    },
    addItem: function addItem() {
      var _value2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default()(this.value),
          value = _value2.slice(0);

      value.push('');
      this.updateInput('value', value);
    },
    removeItem: function removeItem(inIndex) {
      var filtered = this.value.filter(function (item, index) {
        return index !== inIndex;
      });
      this.updateInput('value', filtered);
    }
  }
});

/***/ }),

/***/ "ryq9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddNewFeed_vue__ = __webpack_require__("ktta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4862ce4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddNewFeed_vue__ = __webpack_require__("QCOa");
function injectStyle (ssrContext) {
  __webpack_require__("nhVN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddNewFeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4862ce4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddNewFeed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tW/y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tkif":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tsRJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_Input__ = __webpack_require__("gcDA");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__inputs_Input__["a" /* default */],
  props: ['name']
});

/***/ }),

/***/ "uaPV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uploadcare_widget__ = __webpack_require__("84yM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uploadcare_widget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uploadcare_widget__);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    url: {
      required: true
    }
  },
  data: function data() {
    return {
      uploadcareUrl: "",
      widget: ''
    };
  },
  mounted: function mounted() {
    this.initWidget();
  },

  watch: {
    uploadcareUrl: function uploadcareUrl() {
      this.updatePropUrl();
    },
    url: function url() {
      this.updateWidgetValue();
    }
  },
  methods: {
    initWidget: function initWidget() {
      var _this = this;

      this.widget = __WEBPACK_IMPORTED_MODULE_0_uploadcare_widget___default.a.Widget(this.$el);
      this.updateWidgetValue();

      this.widget.onUploadComplete(function (info) {
        _this.uploadcareUrl = info.cdnUrl;
      });
    },
    updatePropUrl: function updatePropUrl() {
      this.$emit('update:url', this.uploadcareUrl);
    },
    updateWidgetValue: function updateWidgetValue() {
      this.widget && this.widget.value(this.url);
    }
  }
});

/***/ }),

/***/ "urME":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v663":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vBdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_Input__ = __webpack_require__("gcDA");
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__inputs_Input__["a" /* default */],
  props: ['name'],
  computed: {
    textLength: function textLength() {
      return this.value.length;
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__("bwGm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Login__ = __webpack_require__("lmfZ");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    NavigationCom: __WEBPACK_IMPORTED_MODULE_0__components_Navigation__["a" /* default */],
    LoginView: __WEBPACK_IMPORTED_MODULE_1__views_Login__["a" /* default */]
  },
  data: function data() {
    return {
      triedRestoreSession: false
    };
  },

  computed: {
    name: function name() {
      return this.$store.state.userInfo.name;
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.$http.get('http://api.lootbox.se/restoresession', {
        emulateJSON: true,
        withCredentials: true
      }).then(function (_ref) {
        var body = _ref.body;

        _this.triedRestoreSession = true;

        if (!body) {
          return;
        }

        _this.$store.commit({
          type: 'userInfo',
          name: body.name,
          organisation: body.organisation
        });

        if (body.feeds.length) {
          _this.$store.commit('feeds', body.feeds);
        }

        _this.$store.commit('currentFeed', 0);

        console.log('Session restored!');
      }, function () {
        console.log('Fail!');
      });
    }, 1500);
  }
});

/***/ }),

/***/ "ylDi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      password: '',
      newPassword: ''
    };
  },

  methods: {
    changePassword: function changePassword() {
      var _this = this;

      this.$http.post('http://api.lootbox.se/changepassword', {
        password: this.password,
        newPassword: this.newPassword
      }, {
        emulateJSON: true,
        withCredentials: true
      }).then(function (_ref) {
        var body = _ref.body;

        _this.password = '';
        _this.newPassword = '';
      }, function () {
        console.log('Fail!');
      });
    }
  }
});

/***/ }),

/***/ "zTyo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeCurrentFeed_vue__ = __webpack_require__("fZ+3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4147d3e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeCurrentFeed_vue__ = __webpack_require__("e1wv");
function injectStyle (ssrContext) {
  __webpack_require__("dtyd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeCurrentFeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4147d3e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeCurrentFeed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zkCS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usernav_vue__ = __webpack_require__("ndKc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c23805b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usernav_vue__ = __webpack_require__("qlDh");
function injectStyle (ssrContext) {
  __webpack_require__("THEr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usernav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c23805b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usernav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.8d0d0872fe17931c1c37.js